module.exports = __webpack_public_path__ + "img/timemachine@3x.96c3f255.png";